import { Icon } from "@iconify/react";
import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { BaseUrl } from "../../../../../redux/config";
import axios from "axios";
import { getSession } from "../../../../../redux/actions/authActions";

export const PatientCard = ({
  data,
  selectedColor,
  isDisabled,
  HandleClick,
  currentData,
  bookingData
}) => {
  const { user_profile_id, role_id } = getSession();
  const [url, setUrl] = useState(null);
  useEffect(() => {

    if (url) {
      window.location.href = url;
    }
  }, [url]);

  // Extract necessary data from bookingData and currentData
  const { ord_svc_date, ord_svc_time } = bookingData || {};
  const { svc_id, svc_name, svc_cost_amt, svc_svcf_id } = currentData || {};

  // Construct postData object
  const postData = {
    ord_svc_date: ord_svc_date,
    ord_svc_time: ord_svc_time,
    order_dte_tsp: "2022-07-15T12:00:00Z",
    order_tot_amt: svc_cost_amt,
    order_tot_tax: 0.0,
    order_tot_fees: 0.0,
    order_svcf_id: svc_svcf_id,
    user_profile_id: user_profile_id,
    order_svc_user_id: data.svcuser_profile_id,
    order_ship_to_id: 2,
    order_ship_instructions: "",
    order_bill_to_id: 2,
    order_status_id: 1,
    sys_user_id: user_profile_id,
    role_id: role_id,
    sys_source_ip: "192.168.2.2",
    sys_crte_tsp: "2022-07-15T12:00:00Z",
    sys_last_updte_tsp: "2022-07-15T12:30:00Z",
    sys_ord_active_yn: "Y",
    service_order_line: [
      {
        svc_id: svc_id,
        svc_name: svc_name,
        svc_qnty_nbr: 1,
        svc_status_id: 1,
        svc_price_amt: svc_cost_amt,
        svcfee_id: 1,
        sys_user_id: user_profile_id,
        sys_ordl_active_yn: "Y",
        sys_crte_tsp: "2022-07-15T12:00:00Z",
        sys_last_updte_tsp: "2022-07-15T12:30:00Z",
      },
    ],
  };

  // handleSubmit function to handle the payment process
  const handleSubmit = async () => {
    const { token } = getSession();
    try {
      let response = await axios.post(`${BaseUrl}pay/ps`, postData, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      setUrl(response.data.session_url);
      return response.data;
    } catch (error) {
      console.error("There was a problem with your Axios request:", error);
    }
  };

  return (
    <div
      className="facility"
      onClick={HandleClick}
      style={{
        paddingBottom: "70px",
        position: "relative",
        border:
          selectedColor === data.svcuser_profile_id
            ? "2px solid #3b71ca"
            : "2px solid transparent",
        cursor: "pointer",
      }}
    >
      <div className="bottom_p">
        <h4>
          <b>Patient Name:</b> {`${data.user_first_name} ${data.user_last_name}`}
        </h4>
        <h4>
          <b>Phone Number:</b> {data.user_phone_nbr}
        </h4>
        <h4>
          <b>Country:</b> {data.user_iso_cntry_cde}
        </h4>
        <h4>
          <b>City:</b> {data.user_iso_city_name}
        </h4>
        <h4>
          <b>Pincode:</b> {data.addr_zipcode}
        </h4>
        <div
          className="w-100 p-3"
          style={{ position: "absolute", bottom: "0px", left: "0px" }}
        >
          <Button
            className="sign_btn"
            disabled={isDisabled === data.svcuser_profile_id ? false : true}
            style={{ boxSizing: "border-box" }}
            onClick={handleSubmit}
          >
            Pay
          </Button>
        </div>
      </div>
    </div>
  );
};
